import React from 'react';
import { Breadcrumb } from 'antd';
const BreadCrumb = ({ items, className, ...props }) => (
    <Breadcrumb
        className={className}
        items={items}
    />
);
export default BreadCrumb;